/**
 *
 * QuestionnaireEditQuestion
 *
 */

import React, { memo, FunctionComponent } from 'react';
import {Wrap} from "../../../../assets/styledAssets/grid";
import { addSection } from '../../Questionnaires.actions';
import {
  addAnswer,
  addQuestion, copyQuestion,
  copySection, editAnswer,
  editQuestion, editSection,
  removeAnswer,
  removeQuestion, removeSection,
} from "../../Questionnaires.slice";
import {RootState} from "../../../../app/store";
import {connect, ConnectedProps} from "react-redux";
import QuestionnaireSection from '../QuestionnaireSection/QuestionnaireSection.component';
import QuestionnaireQuestion from '../QuestionnaireQuestion/QuestionnaireQuestion.component';

const connector = connect(
  (state: RootState) => ({
    activeQuestionnaire: state.questionnaires.activeQuestionnaire,
  }),
  {
    editSection,
    editQuestion,
    editAnswer,
    addSection,
    addQuestion,
    addAnswer,
    removeSection,
    removeAnswer,
    removeQuestion,
    copySection,
    copyQuestion,
  },
);

interface ComponentProps {}

type PropsFromRedux = ConnectedProps<typeof connector>;

const QuestionnaireEditQuestion: FunctionComponent<PropsFromRedux & ComponentProps> = ({
  activeQuestionnaire,
  editSection,
  editQuestion,
  editAnswer,
  addSection,
  addQuestion,
  addAnswer,
  removeSection,
  removeAnswer,
  removeQuestion,
  copySection,
  copyQuestion,
}) => {

  return (
    <Wrap
      flexDir={'column'}
      flexWrap={'nowrap'}
      margin={'0 0 2.4rem 0'}
      width={'100%'}
      overflow={'auto'}
      height={'100%'}
    >
      {activeQuestionnaire?.questionSeries.map((series: any, index: number) => (
        <Wrap key={`series-${index}`} width={'100%'} margin={'0 0 3rem 0'}>
          <QuestionnaireSection
            series={series}
            index={index}
            total={activeQuestionnaire?.questionSeries.length}
            editSection={editSection}
            addSection={addSection}
            addQuestion={addQuestion}
            removeSection={removeSection}
            copySection={copySection}
          />
          {series.questions.map((question: any, qIdx: any) => (
            <QuestionnaireQuestion
              key={`question-${qIdx}`}
              question={question}
              index={qIdx}
              seriesIndex={index}
              editQuestion={editQuestion}
              editAnswer={editAnswer}
              addSection={addSection}
              addQuestion={addQuestion}
              addAnswer={addAnswer}
              removeQuestion={removeQuestion}
              removeAnswer={removeAnswer}
              copyQuestion={copyQuestion}
            />
          ))}
        </Wrap>
      ))}
    </Wrap>
  );
}

export default memo(QuestionnaireEditQuestion);
